import template from './stGlobalPreloader.html';
import controller from './stGlobalPreloader.controller';

let stGlobalPreloaderComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default stGlobalPreloaderComponent;



// WEBPACK FOOTER //
// ./client/app/common/stGlobalPreloader/stGlobalPreloader.component.js